<template>
    <v-flex class="text-body-2">
        <div v-if="feeLoading">
            <v-progress-circular
                :size="60"
                :width="6"
                indeterminate
                class="my-3"
            />
        </div>
        <v-card v-else>
            <v-toolbar class="text-h6 mb-4" :class="darkMode ? '' : 'mt-1'">Total</v-toolbar>
            <v-flex class="text-body-2 font-italic px-3 pt-1 pb-3" v-if="!cart.length">Add units...</v-flex>
            <v-layout v-else column>
                <v-layout v-for="(subtotal, i) in cart" :key="i" class="px-3 pb-2">
                    <v-flex xs6>
                        Unit {{ subtotal.unit }}
                    </v-flex>
                    <v-flex xs2 class="text-right">
                        ${{ parseFloat(subtotal.total).toFixed(2) }}
                    </v-flex>
                </v-layout>
<!--                @TODO: Uncomment when convenience fees are reactivated.-->
<!--                <v-layout class="px-3" align-center>-->
<!--                    <v-flex xs6>-->
<!--                        Convenience Fee:-->
<!--                    </v-flex>-->
<!--                    <v-flex xs2 class="text-xs-right">-->
<!--                        ${{ parseFloat(convenienceFees.dcPrice).toFixed(2) }}-->
<!--                    </v-flex>-->
<!--                    <v-flex xs4 class="text-xs-center">-->
<!--                        <v-btn-->
<!--                            v-if="!convenienceFeeStatus"-->
<!--                            small-->
<!--                            outline-->
<!--                            class="error ml-5"-->
<!--                            @click="waiveConvenienceFee"-->
<!--                            :disabled="!recording"-->
<!--                        >Waive Fee</v-btn>-->
<!--                        <span v-else-if="convenienceWaived">Waived</span>-->
<!--                        <span v-else small class="error&#45;&#45;text caption ml-2">Last waived {{ formatDate(convenienceFeeStatus.updated_at) }}</span>-->
<!--                    </v-flex>-->
<!--                </v-layout>-->
                <v-divider class="mx-1 my-3" />
                <v-layout class="subheading font-weight-bold pb-3 px-3">
                    <v-flex xs6>
                        Non-refundable Total Charges:
                    </v-flex>
                    <v-flex xs2 class="text-right">
<!--                        @TODO: Uncomment when convenience fees are reactivated... and move the evaluation out of the template for godssakes smh @conor - Conor -->
<!--                        ${{ (totalCharges(cart) + parseFloat(convenienceFees.dcPrice)).toFixed(2) }}-->
                        ${{ totalCharges(cart).toFixed(2) }}
                    </v-flex>
                </v-layout>
            </v-layout>
        </v-card>
    </v-flex>
</template>

<script>
/* eslint-disable no-return-assign */
import { mapState } from "vuex";
import moment from "moment";

export default {
  props: [
    "feeLoading"
    // "convenienceFees", @TODO: Uncomment when convenience fees are reactivated.
    // "convenienceFeeStatus", @TODO: Uncomment when convenience fees are reactivated.
    // "convenienceWaived", @TODO: Uncomment when convenience fees are reactivated.
  ],

  computed: {
    ...mapState({
      cart: state => state.tenant.payment.cart,
      recording: state => state.call.recording,
      darkMode: state => state.application.settings.darkTheme
    })
  },

  methods: {
    formatDate(date) {
      return moment.utc(date).local().format("MM-DD-YYYY");
    },

    totalBalance(initialCharges) {
      return this.totalCharges(initialCharges);
    },

    totalCharges(arr) {
      return arr.reduce((acc, currVal) => {
        return acc += parseFloat(currVal.total);
      }, 0);
    }

    // waiveConvenienceFee() { @TODO: Uncomment when convenience fees are reactivated.
    //     this.$emit("waiveConvenienceFee");
    // },

  }
};
</script>
